import { render } from "./Reviews.vue?vue&type=template&id=02a0b98b"
import script from "./Reviews.vue?vue&type=script&lang=js"
export * from "./Reviews.vue?vue&type=script&lang=js"

import exportComponent from "/Users/palla/Development/improvers/kon-platform-wallboards-frontend/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.39_vue@3.5.39_typescript@7.0.2__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__